var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositiveSentimentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "face-smile",
    clipPath: "url(#clip0_2489_7015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.6665 11.6667C6.6665 11.6667 7.9165 13.3334 9.99984 13.3334C12.0832 13.3334 13.3332 11.6667 13.3332 11.6667M12.4998 7.50002H12.5082M7.49984 7.50002H7.50817M18.3332 10C18.3332 14.6024 14.6022 18.3334 9.99984 18.3334C5.39746 18.3334 1.6665 14.6024 1.6665 10C1.6665 5.39765 5.39746 1.66669 9.99984 1.66669C14.6022 1.66669 18.3332 5.39765 18.3332 10ZM12.9165 7.50002C12.9165 7.73014 12.73 7.91669 12.4998 7.91669C12.2697 7.91669 12.0832 7.73014 12.0832 7.50002C12.0832 7.2699 12.2697 7.08335 12.4998 7.08335C12.73 7.08335 12.9165 7.2699 12.9165 7.50002ZM7.9165 7.50002C7.9165 7.73014 7.72996 7.91669 7.49984 7.91669C7.26972 7.91669 7.08317 7.73014 7.08317 7.50002C7.08317 7.2699 7.26972 7.08335 7.49984 7.08335C7.72996 7.08335 7.9165 7.2699 7.9165 7.50002Z",
    stroke: "#C0FAD6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2489_7015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositiveSentimentIcon);
export default __webpack_public_path__ + "static/media/positive_sentiment_icon.d0cd842908521b4601c9932af2af5907.svg";
export { ForwardRef as ReactComponent };